import React from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';

import Checkbox from '../../components/forms/checkbox';

@observer
export default class AppFormCheckboxList extends React.Component {
  static propTypes = {
    disabled: PropTypes.bool,
    newAppMasterStore: PropTypes.object.isRequired,
    required: PropTypes.bool,
    saveRef: PropTypes.func.isRequired,
    type: PropTypes.string.isRequired
  };

  static defaultProps = {
    disabled: false,
    required: false
  };

  constructor(props) {
    super(props);
    this.newAppDetailsStore = this.props.newAppMasterStore.newAppDetailsStore;
  }

  onCheck = target => {
    if (!this.props.disabled) {
      this.newAppDetailsStore.handleCheck(target);
    }
  };

  render() {
    const checkboxList = this.newAppDetailsStore.checkboxFields[this.props.type];
    const hasError = !this.newAppDetailsStore.checkboxIsValid[this.props.type];
    return (
      <fieldset className={`form-group ${hasError ? 'has-error' : ''}`}>
        <legend htmlFor={this.props.type} className="col-form-label">
          <span className={`${this.props.required ? 'required':''}`}>{checkboxList.label}</span>
          {this.props.required &&
            <div className="msgBlock error error-list">
              {hasError ? this.props.newAppMasterStore.REQUIRED_ERROR : ''}
            </div>
          }
         { checkboxList.subtext &&<div className="help-text">{checkboxList.subtext}</div>}
        </legend>
        <div className="row cr-group">
          {checkboxList.values.map((value, index) => {
            const uniqueKey = this.props.type + 'Option' + index;
            return (
              <div className="col-6" key={uniqueKey}>
                <Checkbox
                  id={this.props.type}
                  ref={i => {
                    if (index === 0) {
                      this.props.saveRef(i);
                    }
                  }}
                  value={(this.props.type === 'searchTags') ? value.display : value.name}
                  label={value.display}
                  disabled={this.props.disabled}
                  checked={
                    this.props.newAppMasterStore.newAppData[this.props.type] &&
                    this.props.newAppMasterStore.newAppData[this.props.type].indexOf((this.props.type === 'searchTags') ? value.display : value.name) > -1
                  }
                  handleOnChange={this.onCheck} />
              </div>
            );
          })}
        </div>
      </fieldset>
    );
  }
}
